<ng-container>
  <div [class]="'ap-cr-crop-row-big ap-cr-flex-box'">
    <div [class]="'ap-cr-front-row'"
         [style.border-left.px]="6"
         [style.border-left-color]="mainCrop ? mainCrop.Color : 'transparent'"
         [style.border-left-style]="'solid'">
      <kendo-combobox *ngIf="mainCrop"
                      #mainCropComboBox
                      valueField="Id"
                      textField="Description"
                      [data]="mainCropSource"
                      [clearButton]="false"
                      [value]="mainCrop"
                      [filterable]="true"
                      [aptooltip]="mainCrop.Description"
                      [perpetual]="true"
                      (filterChange)="handleMainCropFilter($event)"
                      [disabled]="disableControls"
                      (valueChange)="onMainCropChange($event)"
                      (focus)="onGetFocus()"
                      (blur)="onLostFocus()"
                      (keydown)="onKeyDown($event)"
                      [popupSettings]="{ popupClass: 'ap-cr-combobox-popup', width: 300 }"
      ></kendo-combobox>
      <button *ngIf="!mainCrop && !disableControls"
              kendoButton
              [class]="'ap-cr-add-button k-button k-primary button-important'"
              [svgIcon]="ApKendoIconService.Get('plusIcon')"
              (click)="onAddMainCrop()"
      ></button>
    </div>
    <div class="ap-cr-back-row">
      <label *ngIf="mainCrop"
             [class]="'ap-cr-flex-box'"
             [for]="strawHarvestedId + '_mainCropYield'">
        <input kendoTextBox
               type="number"
               [min]="0"
               [disabled]="disableControls"
               [class]="'ap-cr-yield-input'"
               [id]="strawHarvestedId + '_mainCropYield'"
               [(ngModel)]="data.MainCropYield"
               (change)="onMainCropYieldChange($event)"
               (focus)="onGetFocus()"
               (blur)="onLostFocus()"
               (keyup)="onYieldKeyUp()"
               (keydown)="onKeyDown($event)"
        />
      </label>
      <input *ngIf="mainCrop"
             [type]="'checkbox'"
             [class]="'k-checkbox'"
             [id]="strawHarvestedId + '_strawHarvested'"
             [disabled]="disableControls"
             [checked]="data ? data.MainCropStraw : false"
             (change)="changeStrawHarvested()"
             (focus)="onGetFocus()"
             (blur)="onLostFocus()"
      />
      <label *ngIf="mainCrop"
             [class]="'k-checkbox-label ap-cr-flex-box'"
             [for]="strawHarvestedId + '_strawHarvested'"></label>
    </div>
  </div>
  <div [class]="'ap-cr-crop-row ap-cr-flex-box'">
    <div [class]="'ap-cr-front-row'"
         [style.border-left.px]="6"
         [style.border-left-color]="secondCrop ? secondCrop.Color : 'transparent'"
         [style.border-left-style]="'solid'">
      <kendo-combobox *ngIf="secondCrop"
                      #secondCropComboBox
                      valueField="Id"
                      textField="Description"
                      [class]="'ap-cr-second-crop-font ap-cr-second-crop-selection'"
                      [disabled]="disableControls"
                      [clearButton]="false"
                      [data]="secondCropSource"
                      [value]="secondCrop"
                      [filterable]="true"
                      [aptooltip]="secondCrop.Description"
                      [perpetual]="true"
                      (filterChange)="handleSecondCropFilter($event)"
                      (valueChange)="onSecondCropChange($event)"
                      (focus)="onGetFocus()"
                      (blur)="onLostFocus()"
                      (keydown)="onKeyDown($event)"
                      [popupSettings]="{ popupClass: 'ap-cr-combobox-popup', width: 300 }"
      ></kendo-combobox>
      <button *ngIf="mainCrop && !secondCrop && !disableControls"
              kendoButton
              [class]="'ap-cr-add-button k-button k-primary button-important'"
              [svgIcon]="ApKendoIconService.Get('plusIcon')"
              (click)="onAddSecondCrop()"
      ></button>
    </div>
    <div [class]="'ap-cr-back-row'">
      <input *ngIf="secondCrop"
             kendoTextBox
             type="number"
             [min]="0"
             [disabled]="disableControls"
             [class]="'ap-cr-yield-input ap-cr-second-crop-font'"
             [id]="strawHarvestedId + '_secondCropYield'"
             [(ngModel)]="data.SecondCropYield"
             (change)="onSecondCropYieldChange($event)"
             (focus)="onGetFocus()"
             (blur)="onLostFocus()"
             (keyup)="onYieldKeyUp()"
             (keydown)="onKeyDown($event)"
      />
      <label *ngIf="secondCrop"
             [id]="strawHarvestedId + '_secondCropYield'"></label>
    </div>
  </div>
</ng-container>
